import { defineSlotRecipe as i } from "@pandacss/dev";
import { createAnatomy as e } from "../../../node_modules/@ark-ui/anatomy/node_modules/@zag-js/anatomy/dist/index.mjs";
const a = e("layout", [
  "root",
  "header",
  "sidebar",
  "asideMenu",
  "content",
  "aside"
]), d = i({
  className: "layout",
  slots: a.keys(),
  base: {
    root: {
      display: "grid",
      height: "100vh",
      gridTemplate: `
        "header header header aside" auto
        "sidebar content aside-menu aside" 1fr
        / min-content 1fr min-content
      `,
      transition: "all 0.2s ease-in-out"
    },
    header: {
      gridArea: "header",
      minHeight: "spacing-10",
      paddingX: "spacing-6",
      paddingY: "spacing-4"
    },
    sidebar: {
      gridArea: "sidebar",
      width: "fit-content",
      minWidth: "min-content",
      whiteSpace: "nowrap",
      transition: "all 0.2s ease-in-out"
    },
    content: {
      gridArea: "content",
      overflow: "auto",
      padding: "4",
      width: "100%",
      transition: "all 0.2s ease-in-out"
    },
    aside: {
      gridArea: "aside",
      width: "fit-content",
      minWidth: "min-content",
      maxWidth: "320px",
      whiteSpace: "nowrap",
      transition: "all 0.2s ease-in-out"
    },
    asideMenu: {
      gridArea: "aside-menu",
      minWidth: "spacing-10",
      paddingX: "spacing-3",
      paddingY: "spacing-6"
    }
  },
  variants: {
    open: {
      sidebar: {
        sidebar: {
          width: "200px"
        },
        aside: {
          display: "none"
        }
      },
      aside: {
        aside: {
          minWidth: "180px"
        }
      },
      none: {
        sidebar: {
          width: "min-content"
        },
        aside: {
          display: "none"
        }
      }
    }
  }
});
export {
  d as layout
};
